import React from "react";
import "../assets/css/AboutPage.css";
import awardImg from "../assets/imgs/Award.JPG";
import ip from '../assets/imgs/ip-sir2.png';

import InnerHeader from "./InnerHeader";


const AboutPage = () => {
    return (

        <>
            <InnerHeader />

            <div className="about-page">

                {/* HERO EDITORIAL CARD */}

                <div className="about-card">

                    <div className="about-left">
                        <img src={ip} alt="Indrajeet Patil" />
                    </div>

                    <div className="about-right">

                        <p className="author">Indrajeet Patil</p>

                        <h1>
                            The Mind Behind <br />
                            Business Transformation
                        </h1>

                        <p className="date">
                            Motivational Speaker | Business Psychologist | Founder
                        </p>

                        <p>
                            Indrajeet Patil is a Motivational Speaker,
                            Educational Counsellor, Business Psychologist
                            and Writer with over 13 years of experience
                            guiding entrepreneurs, professionals and
                            business leaders towards transformational thinking.
                        </p>

                        <p>
                            Through a unique blend of psychology,
                            real-world business insight and leadership
                            training, he has helped thousands of
                            participants understand how mindset,
                            communication and decision-making shape
                            the future of businesses.
                        </p>

                        <blockquote className="first-blockquote" >
                            “Businesses grow when people learn how to think differently.”
                        </blockquote>

                        <p>
                            With hands-on experience in the real estate
                            industry and the creation of multiple
                            organisations including Samriddhi Gurukul,
                            Samriddhi Realtors and Global Manch,
                            he continues to mentor professionals
                            through seminars, leadership workshops
                            and growth programs.
                        </p>

                    </div>
                </div>


                {/* PHILOSOPHY */}

                <section className="about-section">

                    <h2>Philosophy</h2>

                    <p>
                        Indrajeet Patil believes that every business problem
                        is ultimately a thinking problem. The quality of
                        decisions made by entrepreneurs and leaders
                        determines the future of their organisations.
                    </p>

                    <p>
                        By combining psychology, business insight
                        and real-world experience, he helps professionals
                        develop clarity in thinking, communication
                        and leadership.
                    </p>

                </section>


                {/* MISSION */}

                <section className="about-section light">

                    <h2>Mission</h2>

                    <p>
                        To empower entrepreneurs, professionals
                        and business leaders with psychological
                        frameworks that help them think clearly,
                        make powerful decisions and build
                        sustainable growth.
                    </p>

                </section>


                {/* JOURNEY */}

                <section className="timeline">

                    <h2>The Journey</h2>

                    <div className="timeline-items">

                        <div>
                            <h3>2010</h3>
                            <p>Started exploring human behaviour and leadership psychology.</p>
                        </div>

                        <div>
                            <h3>2013</h3>
                            <p>Began mentoring students and professionals.</p>
                        </div>

                        <div>
                            <h3>2018</h3>
                            <p>Founded Samriddhi Gurukul to promote growth-driven learning.</p>
                        </div>

                        <div>
                            <h3>2021</h3>
                            <p>Entered real estate training and sales psychology.</p>
                        </div>

                        <div>
                            <h3>2024</h3>
                            <p>Expanded seminars and leadership workshops for businesses.</p>
                        </div>

                    </div>

                </section>


                {/* ORGANISATIONS */}

                {/* <section className="about-section">

                <h2>Organisations Founded</h2>

                <ul className="org-list">
                    <li>Samriddhi Gurukul</li>
                    <li>Samriddhi Realtors</li>
                    <li>Samriddhi Business Club Global</li>
                    <li>Abhyara Mitra</li>
                    <li>Krishna Fleet</li>
                    <li>INS Group of Companies</li>
                </ul>

            </section> */}


                {/* AWARDS */}

                <section className="awards">

                    <h2>Awards & Recognition</h2>

                    <div className="awards-imgs">
                        <img src={awardImg} alt="Award Ceremony" />
                    </div>

                    <p>
                        Indrajeet Patil has been recognised for his
                        contribution to entrepreneurship and business
                        leadership. His seminars and mentorship
                        programs continue to inspire professionals
                        and business owners across industries.
                    </p>

                </section>


                {/* SPEAKING TOPICS */}

                <section className="about-section light">

                    <h2>Key Speaking Topics</h2>

                    <ul className="topics">

                        <li>Business Psychology</li>
                        <li>Sales Mindset</li>
                        <li>Real Estate Growth Strategies</li>
                        <li>Leadership Behaviour</li>
                        <li>Decision Making Frameworks</li>

                    </ul>

                </section>


                {/* SIGNATURE QUOTE */}

                <section className="quote-section">

                    <blockquote>
                        “When people learn how to think better,
                        businesses automatically grow stronger.”
                    </blockquote>

                </section>


                {/* IDEAS & INSIGHTS */}

                <section className="insights">

                    <h2>Ideas & Insights by Indrajeet Patil</h2>

                    <div className="insight-grid">

                        <div className="insight-card">
                            <h3>Mindset Before Strategy</h3>
                            <p>
                                Business strategies fail when leaders
                                fail to change the way they think.
                            </p>
                        </div>

                        <div className="insight-card">
                            <h3>Psychology of Sales</h3>
                            <p>
                                Buyers do not purchase products —
                                they purchase clarity and confidence.
                            </p>
                        </div>

                        <div className="insight-card">
                            <h3>Decision Making</h3>
                            <p>
                                Great leaders make fewer emotional
                                decisions and more conscious ones.
                            </p>
                        </div>

                    </div>

                </section>

            </div>

        </>

    );
};

export default AboutPage;